(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredient-benefits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ingredient-benefits-equalizer')) {
    /**
     * Desktop only: measures every card's open height (header + bullets) without opening it, and exposes
     * the tallest one as --ib-open-height so any card that opens reaches that same height.
     */
    class IngredientBenefitsEqualizer extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.ingredient-benefits');
        if (!this.root) return;

        this.desktop = window.matchMedia('(min-width: 750px)');
        this.resizeObserver = new ResizeObserver(() => this.schedule());
        this.resizeObserver.observe(this.root);
        this.desktop.addEventListener('change', this.schedule);
        document.fonts?.ready.then(this.schedule);
        this.schedule();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.desktop?.removeEventListener('change', this.schedule);
        cancelAnimationFrame(this.frame);
      }

      schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };

      update() {
        const root = this.root;
        if (!this.desktop.matches) {
          root.style.removeProperty('--ib-open-height');
          return;
        }

        const cards = root.querySelectorAll('.ingredient-benefits__card');
        const probe = document.createElement('div');
        probe.setAttribute('aria-hidden', 'true');
        probe.style.cssText = 'position:absolute;left:-10000px;top:0;visibility:hidden;pointer-events:none;';
        root.appendChild(probe);

        let tallest = 0;
        for (const card of cards) {
          const summary = card.querySelector('.ingredient-benefits__summary');
          const body = card.querySelector('.ingredient-benefits__body');
          if (!summary || !body) continue;

          const clone = body.cloneNode(true);
          clone.style.width = `${card.clientWidth}px`;
          probe.appendChild(clone);

          const border = card.offsetHeight - card.clientHeight;
          tallest = Math.max(tallest, summary.offsetHeight + clone.offsetHeight + border);
        }

        probe.remove();
        if (tallest > 0) root.style.setProperty('--ib-open-height', `${Math.ceil(tallest)}px`);
      }
    }

    customElements.define('ingredient-benefits-equalizer', IngredientBenefitsEqualizer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-extended"]) return;
  try {
    
  if (!customElements.get('sticky-buy-buttons-guard')) {
    /**
     * Keeps the buy buttons inside the sticky Details column visible on short desktop screens.
     * If Details (up to the bottom of the buy buttons) is taller than the space below the sticky header,
     * the sticky top becomes negative so the column scrolls until the buy buttons are in view, then sticks.
     */
    class StickyBuyButtonsGuard extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        this.details = this.section?.querySelector('.product-details.sticky-content--desktop');
        if (!this.details) return;

        this.update = this.update.bind(this);
        this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
        this.resizeObserver.observe(this.details);
        window.addEventListener('resize', this.scheduleUpdate, { passive: true });
        this.scheduleUpdate();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        window.removeEventListener('resize', this.scheduleUpdate);
        this.details?.style.removeProperty('--buy-buttons-sticky-top');
      }

      scheduleUpdate = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(this.update);
      };

      update() {
        const details = this.details;
        const buyButtons = details.querySelector('.buy-buttons-block');
        if (!buyButtons) return;

        details.style.removeProperty('--buy-buttons-sticky-top');

        const bottomMargin = 16;
        const headerOffset = parseFloat(getComputedStyle(details).top) || 0;
        const neededHeight =
          buyButtons.getBoundingClientRect().bottom - details.getBoundingClientRect().top + bottomMargin;

        if (headerOffset + neededHeight > window.innerHeight) {
          details.style.setProperty('--buy-buttons-sticky-top', `${Math.round(window.innerHeight - neededHeight)}px`);
        }
      }
    }

    customElements.define('sticky-buy-buttons-guard', StickyBuyButtonsGuard);
  }

  } catch(e) { console.error(e); }
})();
})();
